var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFluterIosAppDev(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 50,
    viewBox: "0 0 36 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1251_524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.5642 10.1826H36.0015L20.1232 25.8904L16.1992 22.0548L28.5642 10.1826Z",
    fill: "#E98432"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7428 21.3701H35.4995L29.3398 27.5802L35.4995 34.1555H27.7428L21.7656 27.7628L27.7428 21.3701Z",
    fill: "#E98432"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3003 35.8905V45.5708C31.3003 47.3516 29.8402 48.8585 28.0151 48.8585H4.47142C2.64633 48.8585 1.14062 47.3516 1.14062 45.5708V4.47494C1.14062 2.64845 2.64633 1.1416 4.47142 1.1416H28.0151C29.8402 1.1416 31.3003 2.64845 31.3003 4.47494V8.58452",
    stroke: "#F4C135",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1251_524"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFluterIosAppDev);
export default __webpack_public_path__ + "static/media/Fluter-ios-app-dev.c89c4f6770493089c5acbb7aed8c5b73.svg";
export { ForwardRef as ReactComponent };